/**
 * 活动完成清场（支付成功 / 业务主动结束等）
 *
 * 一次调用完成：
 * - 队列：去掉 waiting 中同活动；若 current 属该活动则清空（不落挂件）并续弹其它
 * - 挂件：removeSession
 * - 活动：默认 expireActivity；可选 remove 硬删
 *
 * 业务层不要分别调 expire / removeSession / dismiss，统一走本方法。
 */

import { useActivityStore } from '@/store/activity';
import { useActivityQueueStore } from '@/store/activity-queue';
import { useActivitySessionStore } from '@/store/activity-session';

/** 完成态处理模式 */
export type TCompleteActivityMode = 'expire' | 'remove';

export interface ICompleteActivityOptions {
    /**
     * expire（默认）：ActivityStore 置 expired，弹窗/挂件/offer 卡经 isActivityShowable 不可见
     * remove：硬删 ActivityStore 条目
     */
    mode?: TCompleteActivityMode;
}

/**
 * 标记活动已完成并清场弹窗 / 挂件 / 队列引用。
 * @param activityId 活动 id
 * @param options 清场模式；默认 expire
 */
export function completeActivity(activityId: string, options?: ICompleteActivityOptions): void {
    const id = activityId?.trim();
    if (!id) {
        return;
    }

    const mode: TCompleteActivityMode = options?.mode ?? 'expire';

    useActivityQueueStore.getState().purgeActivityTasks(id);
    useActivitySessionStore.getState().removeSession(id);

    if (mode === 'remove') {
        useActivityStore.getState().removeActivity(id);
    } else {
        useActivityStore.getState().expireActivity(id);
    }
}
